import React from 'react';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { getSkeletonStyles } from './style';

const PaletteSkeleton = React.memo(() => {
  const classes = getSkeletonStyles();
  return (
    <Skeleton className={classes.row}>
      <SkeletonItem className={classes.item} />
      <SkeletonItem className={classes.item} />
    </Skeleton>
  );
});

export { PaletteSkeleton };
